//work data

export const Work = [
  {
    id: 1,
    name: "Netflix Clone ",
    description: "HTML+CSS 활용 클론코딩 프로젝트 -> 리엑트로 재구성 예정",
    tags: ["HTML", "CSS", "JavaScript", "react", "styledComponents"],

    demo: "데모링크 아직 없음",
    github: "https://github.com/croppedeyebrow/front-project",
  },
  {
    id: 2,
    name: "Code8: music site",
    description: "인디 가수 음악 등록 사이트",
    tags: ["react", "styledComponents"],

    demo: "데모링크 아직 없음",
    github: "https://github.com/croppedeyebrow/CODE8-FINAL-FRONT",
  },
  {
    id: 3,
    name: "Marstock",
    description: "주식 정보 제공 및 모의 투자 사이트",
    tags: ["react", "api", "styledComponents"],

    demo: "데모링크 아직 없음",
    github: "https://github.com/croppedeyebrow/marstockfront",
  },

  {
    id: 4,
    name: "프로젝트 이름",
    description: "프로젝트 설명",
    tags: ["react", "styledComponents", "react-router"],

    demo: "",
    github: "https://github.com/croppedeyebrow",
  },

  {
    id: 5,
    name: "프로젝트 이름",
    description: "프로젝트 설명",
    tags: ["react", "styledComponents", "react-router"],

    demo: "",
    github: "https://github.com/croppedeyebrow",
  },
  {
    id: 6,
    name: "프로젝트 이름",
    description: "프로젝트 설명",
    tags: ["react", "styledComponents", "react-router"],

    demo: "",
    github: "https://github.com/croppedeyebrow",
  },
];
